// ----------------------------------------------------------------------------
// Nombre del Programa : session
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para manejar variables de session
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------


export const setToken = (token: string) =>
  window.localStorage.setItem('api_token', token);

export const getToken = () => window.localStorage.getItem('api_token');

export const setRoli = (roli: string) =>
  window.localStorage.setItem('rol_id', roli);

export const getRoli = () => window.localStorage.getItem('rol_id');

export const setUsuarioi = (usuarioi: string) =>
  window.localStorage.setItem('usuario_id', usuarioi);

export const getUsuarioi = () => window.localStorage.getItem('usuario_id');

export const setMenusApi = (data: any) =>
  window.localStorage.setItem('menus', JSON.stringify(data));

export const getMenusApi = () =>
  JSON.parse(window.localStorage.getItem('menus') || '[]');

export const setApiUrl = (apiurl: string) =>
  window.localStorage.setItem('api_url', apiurl);

export const getApiUrl = () => window.localStorage.getItem('api_url');

export const setApiCliGoo = (apigoo: string) =>
  window.localStorage.setItem('api_cligoo', apigoo);

export const getApiCliGoo = () => window.localStorage.getItem('api_cligoo');

export const setApiKe = (apike: string) =>
  window.localStorage.setItem('api_ke', apike);

export const getApiKe = () => window.localStorage.getItem('api_ke');

export const setMaxArcMB = (maxarcmb: string) =>
  window.localStorage.setItem('max_arcmb', maxarcmb);

export const getArcMB = () => window.localStorage.getItem('max_arcmb');

export const setMaxImgMB = (maximgmb: string) =>
  window.localStorage.setItem('max_imgmb', maximgmb);

export const getImgMB = () => window.localStorage.getItem('max_imgmb');
//Modificacion: Marca de Inicio WII C-24-1229-24
export const setadm = (esadm: string) =>
  window.sessionStorage.setItem('es_adm', esadm);

export const getadm = () => window.sessionStorage.getItem('es_adm');


export const setCurrentPa = (token: string) =>
  window.sessionStorage.setItem('courreg', token);

export const getCurrentPa = () => window.sessionStorage.getItem('courreg');

//Modificacion: Marca de Fin WII C-24-1229-24
